import { NgxSliderModule, Options } from '@angular-slider/ngx-slider';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, PLATFORM_ID, Renderer2, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule, AbstractControlDirective, NgControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UtilsService } from '../../../shared/services/utils.service';
import { LoadCalculatorService } from '../../../shared/services/load-calculator.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { JsonDataService } from '../../../shared/services/json-data.service';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { SchemaService } from '../../../shared/services/schema.service';
import { MatInputModule } from '@angular/material/input';
import { DomSanitizer } from '@angular/platform-browser';
import { SolarCalculatorComponent } from '../solar-calculator/solar-calculator.component';
import { FilterCategPipe } from '../../../shared/pipes/filter-categ.pipe';

@Component({
  selector: 'app-load-calculator',
  standalone: true,
  imports: [CommonModule,NgxSliderModule,FormsModule,MatFormFieldModule,MatInputModule,MatRadioModule,MatSelectModule,ReactiveFormsModule,FilterCategPipe],
  templateUrl: './load-calculator.component.html',
  styleUrl: './load-calculator.component.scss'
})
export class LoadCalculatorComponent implements OnInit,OnDestroy {
  @Input('isLoadCalculateOnly') isLoadCalculateOnly: any;
  @Input('loadCalculatorData') earlyLoadCalculatorData: any;
  @Output() calculatedLoad = new EventEmitter();
  sub:Subscription=new Subscription()
  environment: any = environment;
  subCategoriesList: any = [];
  activeCateg!: string;
  showForm2: boolean = false;
  showForm1: boolean = true;
  showForm3: boolean = false
  loadCalculatorResponseInfo: any = {}
  form1!: FormGroup;
  form2!: FormGroup;

  loadPercent: any = [{
    percentname: '25%',
    value: 25
  },
  {
    percentname: '50%',
    value: 50
  },
  {
    percentname: '75%',
    value: 75
  },
  {
    percentname: '100%',
    value: 100
  },
  ]

  value: number = 2;
  options: Options = {
    floor: .5,
    ceil: 10,
    step: 0.5,
    translate: (value: number): string => {
      return value + ' hr';
    },
    showSelectionBar: true,
    autoHideLimitLabels: false
  };

  script:any;
  actualSchemaValue:any;
  constructor(  private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private _loadCalculatorSrvc: LoadCalculatorService, 
    @Inject(PLATFORM_ID) private platformId: Object, 
    public utils: UtilsService, private router: Router, 
    public dialog: MatDialog, private route: ActivatedRoute, 
    private jsonDataService: JsonDataService, 
    private metaSvc: MetaMgmtService, 
    private schemaService: SchemaService, 
    private sanitizer: DomSanitizer,
    private analyticsService: AnalyticsService,
    public dialogRef: MatDialogRef<SolarCalculatorComponent>,
    public dialogReff: MatDialogRef<LoadCalculatorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) {
      setTimeout(() => {
        this.isLoadCalculateOnly = this.data ? this.data.isLoadCalculatorSection:'';
        this.earlyLoadCalculatorData = this.data ? this.data.loadCaluculatorData:'';
      },100)
    this.utils.showHeaderFooter.next(true);
    this.sub.add(this.jsonDataService.getMetaDataJsonData().subscribe({
      next: (res: any) => {
        this.utils.hideLoading()
        const activeRouter = this.utils.getActiveRouter(this.router.url);
        const metaDataFilter = res.find((x: any) => activeRouter === x.name);
        let metaData = {
          canonicalURL: metaDataFilter?.canonicalUrl || '',
          description: metaDataFilter?.description || '',
          pageTitle: metaDataFilter?.title || '',
        };
        this.metaSvc.updateMetaTags(metaData);
      error: (err: any) => {
        this.utils.hideLoading()
        console.error('Error fetching meta data', err);
      }
    }}));
  }
  stateChanges!: Observable<void>;
  id!: string;
  placeholder!: string;
  ngControl!: NgControl | AbstractControlDirective | null;
  focused!: boolean;
  empty!: boolean;
  shouldLabelFloat!: boolean;
  required!: boolean;
  disabled!: boolean;
  errorState!: boolean;
  controlType?: string | undefined;
  autofilled?: boolean | undefined;
  userAriaDescribedBy?: string | undefined;
  disableAutomaticLabeling?: boolean | undefined;
  setDescribedByIds(ids: string[]): void {
    throw new Error('Method not implemented.');
  }
  onContainerClick(event: MouseEvent): void {
    throw new Error('Method not implemented.');
  }

  ngOnInit(): void {
    this.form1 = new FormGroup({
      totalWatts: new FormControl(0, [Validators.required, Validators.min(1)]),
      avgRunningLoadPercent: new FormControl((this.isLoadCalculateOnly ? 100 : ''), [Validators.required]),
    });
    this.getApplianceData();
    this.callSchema();

  }
  async callSchema(){
    this.actualSchemaValue = await this.schemaService.addSchema();
    const jsonString = JSON.stringify(this.actualSchemaValue);
    const safeJson = this.sanitizer.bypassSecurityTrustHtml(jsonString);
    this.script  = this._renderer2.createElement('script');
    this.script.type = `application/ld+json`;
    this.script.text = safeJson as string;
    // this.script.text = JSON.stringify(this.actualSchemaValue);
    this._renderer2.appendChild(this._document.body, this.script);
  }
  getApplianceData() {
    if (isPlatformBrowser(this.platformId)) {

    this.utils.showLoading();
    this.sub.add( this._loadCalculatorSrvc.getLoadCategories('79A36F64-2BC2-4537-9729-8FC57557C967')
      .subscribe({
        next: (response: any) => {
          this.utils.hideLoading()
          if (response.success) {
            this.subCategoriesList = response.categoriesList[0].subCategoriesList;
            this.activeCateg = this.subCategoriesList[0].subCategoryName;
            let avgRunningLoad: any;
            let totalWatt: any;
            if (this.isLoadCalculateOnly) {
              this.totalItemCountArr = this.earlyLoadCalculatorData && this.earlyLoadCalculatorData.loadCaluculatorData ? JSON.parse(JSON.stringify(this.earlyLoadCalculatorData.loadCaluculatorData)) : [];
              totalWatt = this.earlyLoadCalculatorData && this.earlyLoadCalculatorData.totalWatts ? this.earlyLoadCalculatorData.totalWatts : 0;
              avgRunningLoad = 100;
            }
            else {
              let loadCalcData: any = localStorage.getItem('loadCalculatorData')
              this.totalItemCountArr = loadCalcData ? JSON.parse(loadCalcData) : [];
              avgRunningLoad = localStorage.getItem('avgRunningLoad') ? Number(localStorage.getItem('avgRunningLoad')) : '';
              totalWatt = localStorage.getItem('totalWatts') ? localStorage.getItem('totalWatts') : '';
            }
            this.form1.controls['avgRunningLoadPercent'].setValue(avgRunningLoad);
            this.form1.controls['totalWatts'].setValue(totalWatt);
            this.value = Number(localStorage.getItem('backupReq') ? localStorage.getItem('backupReq') : 2)
          }
          else {
            this.subCategoriesList = []
          }
          this.utils.hideLoading();
        }
      }))
  }}

  submitForm1() {
    if (this.isLoadCalculateOnly) {
      this.calculatedLoad.emit({ totalWatts: this.form1.value.totalWatts, totalItemCountArr: this.totalItemCountArr, avgRunningLoad: this.form1.value.avgRunningLoadPercent });
      let data:any = { totalWatts: this.form1.value.totalWatts, totalItemCountArr: this.totalItemCountArr, avgRunningLoad: this.form1.value.avgRunningLoadPercent };
      this.dialogReff.close(data)
    }
    else {
      if (isPlatformBrowser(this.platformId)) {
        window.scrollTo(0, 0);
      }
      if (this.form1.valid) {
        this.showForm2 = true;
        this.showForm1 = false
        this.triggerLoadRequireSubmit();
      }
    }
  }

  triggerLoadRequireSubmit() {
    let loadDetailArray = this.totalItemCountArr.map((data: any) => {
      return { [((data['itemName'].split('_'))[0] + ' ' + data['watts'] + 'W').toString()]: data['count'] }
    })
    const data = {
      eventName: "Load Requirement Submitted",
      eventData: {
        'Total Load (W)': this.form1.value.totalWatts ? Number(this.form1.value.totalWatts) : 0,
        'Average Running Load (%)': this.form1.value.avgRunningLoadPercent,
        'Load Details': loadDetailArray
      }
    };
    this.analyticsService.trackData(data);
  }

  submitForm2() {
    this.utils.showLoading();
    if (this.form1.valid && this.value >= .5) {
      let formValues = {
        watts: this.form1.value.totalWatts,
        backupHours: this.value,
        avgRunningLoad: this.form1.value.avgRunningLoadPercent
      }

      this.sub.add(  this._loadCalculatorSrvc.submitLoadValues(formValues)
        .subscribe(
          {
            next: (res: any) => {
              this.utils.hideLoading();
              if (res.success && res.loadCalculatorResponseInfo && res.loadCalculatorResponseInfo.no_Of_Batteries) {
                this.showForm3 = true;
                this.showForm2 = false;
                this.showForm1 = false;
                this.triggerBackupRequireSubmit();
                this.loadCalculatorResponseInfo = res.loadCalculatorResponseInfo;

              }
              else if (!res.loadCalculatorResponseInfo || (res.loadCalculatorResponseInfo && !res.loadCalculatorResponseInfo.no_Of_Batteries)) {
                this.openDialog();
              }
              else {
                if (res.statusCode == 'LC500' && res.message == "Kindly reduce back-up time/load") {
                  this.openDialog();
                }
                else {
                  this.utils.openSnackBar(res.message, 'error-toster');
                }
              }
            },
            error: () => {
              this.utils.hideLoading();
            },
          }
        ))
    }
  }

  triggerBackupRequireSubmit() {
    const data = {
      eventName: "Backup Requirement Submitted",
      eventData: {
        'In Hours': this.value
      }
    };
    this.analyticsService.trackData(data);
  }

  openDialog() {
    // const dialogRef = this.dialog.open(SharedModelComponent, {
    //   disableClose: true,
    //   panelClass: 'cookiesModel',
    //   data: {
    //     title: 'Reduce back-up time/load',
    //     content: 'You should consider reducing back-up time/load close to as real as possible to have an optimum solution.',
    //     closeBtnText: "Re-Calculate",
    //     confirmBtnText: "",
    //     isConfirmation: true,
    //   }
    // });
    // this.sub.add(  dialogRef.afterClosed().subscribe((res: any) => {
    //   if (res) {
    //     this.router.navigate(['/']);
    //   }
    //   else {
    //     this.showForm1 = true;
    //     this.showForm2 = false;
    //     this.showForm3 = false;
    //   }
    // }));
  }
  totalwattArr: number = 0;
  totalItemCountArr: any = []


  handleWatt(type: string, productName: string, watts: string) {
    if (type == 'add') {
      const i = this.totalItemCountArr.findIndex((_element: any) =>
        _element.itemName.toLowerCase() === (productName + '_' + watts).toLowerCase()
      );
      if (i > -1) {
        this.totalItemCountArr[i].count += 1;
      }
      else {
        this.totalItemCountArr.push({
          itemName: productName + '_' + watts,
          watts: watts,
          count: 1
        })
      }
    }

    if (type == 'minus') {
      const i = this.totalItemCountArr.findIndex((_element: any) =>
        _element.itemName.toLowerCase() === (productName + '_' + watts).toLowerCase()
      );
      if (i > -1) {
        this.totalItemCountArr[i].count -= 1;
      }
    }

    let totalWatts: any = 0;
    this.totalwattArr = 0;
    this.totalItemCountArr.forEach((element: any) => {
      totalWatts += Number(element.watts) * Number(element.count);
    });
    this.totalwattArr = totalWatts;

    this.form1.patchValue({
      totalWatts: this.totalwattArr
    })

  }


  getCount(currentItem: string, watts: string) {
    if (currentItem.length) {
      let obj = this.totalItemCountArr.find((o: any) => o?.itemName === currentItem + '_' + watts);
      return obj?.count
    }
  }

  selectSubCateg(subCatName: string) {
    this.activeCateg = subCatName
  }

  openAccordionIndex: number = 0;

  accordionHandler(index: number, subCatName: string) {
    if (index == this.openAccordionIndex) {
      this.openAccordionIndex = -5;
    }
    else
      this.openAccordionIndex = index;
    this.activeCateg = subCatName

  }

  goToRecommendedProd(type?: string) {
    if (isPlatformBrowser(this.platformId)) {

    if (type == 'Battery') {
      this.loadCalculatorResponseInfo.inverter_VA_Rating = 1;
    }
    if (type == 'Inverter') {
      this.loadCalculatorResponseInfo.battery_Capacity = 1;
    }
    this.triggerRecommendedSol()
    let data: any = JSON.stringify(this.totalItemCountArr)
    localStorage.setItem('loadCalculatorData', data);
    localStorage.setItem('avgRunningLoad', this.form1.value.avgRunningLoadPercent);
    localStorage.setItem('totalWatts', this.form1.value.totalWatts);
    localStorage.setItem('backupReq', String(this.value));

    this.router.navigate(
      ['/recommended-solution'],
      { queryParams: { vaSuggested: this.loadCalculatorResponseInfo.inverter_VA_Rating, ahSuggested: this.loadCalculatorResponseInfo.battery_Capacity } }
    );
  }
  }
  triggerRecommendedSol() {
    const data = {
      eventName: "Recommended Solutions Viewed",
      eventData: {
        'Pincode': Number(this.utils.getUserPicode()) || 0
      }
    };
    this.analyticsService.trackData(data);
  }

  gotoStep(stepCount: any, resetAll: any) {
    if (resetAll) {
      this.getApplianceData();
      this.form1.reset();
      this.value = 5;
      this.totalItemCountArr = [];
    }
    switch (stepCount) {
      case 1: {
        this.showForm1 = true;
        this.showForm2 = false;
        this.showForm3 = false;
        break;
      }
    }
  }

  fetchClassNameByName(name: any, isActive: boolean) {
    let className: any = '';
    switch (name.toLowerCase()) {
      case 'fans and coolers': {
        className = 'fan';
        break;
      }
      case 'laptops and computers': {
        className = 'laptop';
        break;
      }
      case 'lights': {
        className = 'light';
        break;
      }
      case 'home appliances': {
        className = 'appliances';
        break;
      }
      case 'tv & other entertainment': {
        className = 'tv';
        break;
      }
      case 'acs': {
        className = 'ac';
        break;
      }
      case 'motors': {
        className = 'motor';
        break;
      }
      case 'others': {
        className = 'other';
        break;
      }
      default: {
        className = 'other';
        break;
      }
    }
    if (isActive) {
      className += ' active';
    }
    return className;
  }
  getImageByName(name: any, isActive: boolean) {
    let imgUrl: any = environment.blobUrl+'/assets/images/load-calc/';
    let imgName: any = '';
    switch (name.toLowerCase()) {
      case 'fans and coolers': {
        imgName = 'fan';
        break;
      }
      case 'laptops and computers': {
        imgName = 'laptop';
        break;
      }
      case 'lights': {
        imgName = 'light';
        break;
      }
      case 'home appliances': {
        imgName = 'appliances';
        break;
      }
      case 'tv & other entertainment': {
        imgName = 'tv';
        break;
      }
      case 'acs': {
        imgName = 'ac';
        break;
      }
      case 'motors': {
        imgName = 'motor';
        break;
      }
      case 'others': {
        imgName = 'other';
        break;
      }
      default: {
        imgName = 'other';
        break;
      }
    }
    if (isActive) {
      imgUrl += imgName + '-blue.svg';
    }
    else {
      imgUrl += imgName + '.svg';
    }
    return imgUrl;
  }

  getSelectedQuantityCount(cat: any) {
    let totalCount = 0;
    if (this.totalItemCountArr && this.totalItemCountArr.length) {
      cat.products.forEach((element: any) => {
        let filter = this.totalItemCountArr.filter((selectedEle: any) => {
          if (selectedEle.itemName.toLowerCase() === (element.productName + '_' + element.watts).toLowerCase()) {
            return selectedEle;
          }
        })
        if (filter && filter.length) {
          totalCount += Number(filter[0].count) * Number(filter[0].watts);
        }
      })
    }
    return totalCount ? '(' + totalCount + 'W)' : ''
  }
  closeDialog(){
    this.dialog.closeAll()
  }
  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }
}
